import React, { useMemo, useState } from 'react';
import './SearchableSelect.css';

function normalizeText(value = '') {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function SearchableSelect({
  value,
  onChange,
  options = [],
  placeholder = 'Selecione uma opção',
  searchPlaceholder = 'Digite para filtrar',
  required = false,
  disabled = false,
  noResultsText = 'Nenhuma opção encontrada',
  className = '',
}) {
  const [search, setSearch] = useState('');

  const filteredOptions = useMemo(() => {
    if (!search.trim()) {
      return options;
    }

    const normalizedSearch = normalizeText(search);

    return options.filter((option) => {
      const haystack = `${option.label || ''} ${option.searchText || ''}`;
      return normalizeText(haystack).includes(normalizedSearch);
    });
  }, [options, search]);

  return (
    <div className={`searchable-select ${className}`.trim()}>
      <input
        type="text"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        placeholder={searchPlaceholder}
        disabled={disabled}
      />
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        required={required}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {filteredOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {search.trim() && filteredOptions.length === 0 && (
        <small className="searchable-select-empty">{noResultsText}</small>
      )}
    </div>
  );
}

export default SearchableSelect;
